export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14675.82c6086b.jpg";